import React from 'react';

export const AnalyzeAssetsSolar = () => {
  return <div> Analyze Assets Solar </div>;
};

AnalyzeAssetsSolar.propTypes = {};

AnalyzeAssetsSolar.defaultProps = {};
